import * as React from "react";
import * as types from "../../constants/actionTypes";
import * as Tools from "../../helpers/Tools";
import * as msgs from "../../constants/textConstants";
import { connect } from "react-redux";
import { withRouter } from 'react-router';
import { logUI } from "../../api/andyliticsApi";
import DataComponent from "../common/DataComponent";
import MiniSpinner from "../common/MiniSpinner";
import { Card, Divider, LinkText, Notifier, Typography } from "../ecosystem";
import { PageHeading } from "../ecosystem/mybswh";
import FavoriteDrCard from "./FavoriteDrCard";
import RecentDrCard from "./RecentDrCard";
import FindCareForm from "../care/FindCareForm";
import FindCareButton from "../care/FindCareButton";
import DrawerFindCare from "../care/DrawerFindCare"
import FavoriteDrHeadings from "./FavoriteDrHeadings";
import FavDocTips from "./FavDocTips";
import { queryParams } from "../../helpers/formatting";


const USE_CURRENT_LOCATION = 'Current Location';

class MyFavoriteProviders extends DataComponent {

    constructor(props) {
        super(props);


        const { waitingOnGeoAddress, cityAddress, stateAddress } = this.props;
        this.isCurrentGeoLoc = false;
        const geoAddr = !waitingOnGeoAddress && cityAddress && stateAddress && `${cityAddress},${stateAddress}`;
        const cityZipLoc = geoAddr
            ? geoAddr : this.props.isCurrentLocation && USE_CURRENT_LOCATION;

        this.state = {
            keyword: '',
            keywordList: [],
            overrideRules: false,
            insurance: '',
            cityZip: cityZipLoc,
            drawerOpen: false,
            vector: ''
        };
        this.providerCard = this.providerCard.bind(this);
        this.navToProvider = this.navToProvider.bind(this);

    }


    componentDidMount() {
        if (super.componentDidMount) { super.componentDidMount(); }
        this.props.loadRecentVisitedDoctors();
        logUI("MBHWeb.UI.MyFavoriteProviders.ComponentDidMount", new Date(), Tools.getURLPath());
        this.setState({ ...this.state, insurance: this.props.insuranceName ? this.props.insuranceName : '' })
    }

    shouldLoadData() {
        const { IsLoggedIn, FavoriteProviders, fetchingFavoriteProviders } = this.props;
        return IsLoggedIn && !FavoriteProviders && !fetchingFavoriteProviders;
    }

    loadData() {
        const { loadFavoriteProviders } = this.props;
        loadFavoriteProviders();
    }


    navToProvider(e, npi) {
        if (e.target && e.target.classList && e.target.classList.contains("appt-time-more")) {
            e.preventDefault();
            return;
        }
        const { history } = this.props;
        history.push("/providers/" + npi);
    }

    providerCard(provider, index) {
        let { isMobile, isTablet, onlineSchedulingEnabled } = this.props;

        return (
            <FavoriteDrCard
                key={index}
                isMobile={isMobile}
                isTablet={isTablet}
                npi={provider ? provider?.npi : ''}
                onlineSchedulingEnabled={onlineSchedulingEnabled}
                provider={provider}
            />
        )
    }

    recentDoctors(provider, index) {
        let { isMobile } = this.props;

        return (
            <RecentDrCard
                key={index}
                isMobile={isMobile}
                npi={provider ? provider?.ProviderNPI : ''}
                provider={provider}
            />
        )
    }

    toggleDrawer = () => {
        this.setState({
            drawerOpen: !this.state.drawerOpen
        });
    }

    onCityZipChange(val) {
        this.setState({ cityZip: val });
    }

    redirectToFindCare = (filters = null, params = null) => {
        const { latitude, longitude } = this.props;
        let findcareSearchParms = '?' + queryParams({
            keyword: params && params.keyword ? encodeURIComponent(params.keyword) : this.state.keyword ? encodeURIComponent(this.state.keyword) : null,
            insurance: this.state.insurance ? encodeURIComponent(this.state.insurance) : null,
            location: this.state.cityZip ? this.state.cityZip === USE_CURRENT_LOCATION ? latitude + ',' + longitude : encodeURIComponent(this.state.cityZip) : null,
            vector: params && params.vectorName ? params.vectorName : this.state.vector ? this.state.vector : null
        });
        this.props.history.push({ pathname: '/findcare', search: findcareSearchParms });
    }


    render() {
        const {
            FavoriteProviders,
            isMobile,
            isTablet,
            recentVisitedDoctors,
            searchModel,
            screenBreakPoint,
            isCurrentLocation,
            getGeoLocation,
            geolocationError
        } = this.props;
        const { drawerOpen } = this.state;

        let pageHeaderDescription = <>
            Create a list of favorite doctors for future reference when you are searching for a new physician or specialist.
        </>
        let findCareFormProps = {
            keyword: this.state.keyword,
            insurance: this.state.insurance,
            setInsurance: (val) => this.setState({ insurance: val }),
            searchProviders: this.searchProviders,
            cityZip: this.state.cityZip,
            setKeyword: (val) => this.setState({ keyword: val }),
            setKeywordList: (val) => this.setState({ keywordList: val }),
            setVector: (val) => this.setState({ vector: val }),
            setCityZip: (val) => this.onCityZipChange(val),
            searchLocations: this.searchLocations,
            history: this.props.history,
            searchProvidersAndLocations: () => this.redirectToFindCare(),
            searchProviders: (filters, params) => this.redirectToFindCare(filters, params),
            searchLocations: (filters, params) => this.redirectToFindCare(filters, params),
            loading: this.props.searchRunning || this.props.searchLocationsRunning,
            isFormOpen: this.props.searchModel && this.props.searchModel.isFormOpen,
            screenBreakPoint: this.props.screenBreakPoint,
            onFormToggle: isFormOpen => this.props.searchModel.isFormOpen = isFormOpen,
            getGeoLocation: (isLocation) => { getGeoLocation(isLocation); },
            geoLocationError: geolocationError,
            isCurrentLocation: isCurrentLocation,
            networkCode: this.props.networkCode,
            userInsurancePlan: this.props.insuranceName,
            currentLat: this.latitudeFromUrgentCare ? this.latitudeFromUrgentCare : this.latitude ? this.latitude : this.props.latitude,
            currentLong: this.longitudeFromUrgentCare ? this.longitudeFromUrgentCare : this.longitude ? this.longitude : this.props.longitude,
            getGeoLocation: (isLocation) => { this.props.getGeoLocation(isLocation); this.isCurrentGeoLoc = isLocation; },
            variant: 'favorites'
        };
        const isDrawerForm = ([msgs.XS_MOBILE, msgs.SM_MOBILE, msgs.MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

        return (
            <React.Fragment>
                <PageHeading heading="Favorite Doctors"
                    description={pageHeaderDescription}
                    bodyOffset
                />

                {isDrawerForm
                    ? <>
                        <div className="favorite-doctors__find-care-btn-wrapper main-menu-offset__margin-left main-menu-offset__content-width">
                            <FindCareButton
                                fluid
                                onClick={
                                    () => {
                                        this.setState({
                                            drawerOpen: true
                                        });
                                        logUI(`MBHWeb.UI.MyFavoriteProviders.Clicked`, new Date(), Tools.getURLPath());

                                    }
                                }
                            />
                        </div>
                        <DrawerFindCare
                            open={drawerOpen}
                            toggle={this.toggleDrawer}
                        >
                            <FindCareForm
                                {...findCareFormProps}
                            />
                        </DrawerFindCare>
                    </>
                    :
                    <FindCareForm
                        {...findCareFormProps}
                        termsVariant={'secondary'}
                    />
                }



                {
                    (!FavoriteProviders)
                        ? <MiniSpinner />
                        : <div className="row">
                            <div className="col-12 col-lg-6">

                                <Notifier icon="alert" className="banner-wrapper">
                                    If this is an emergency, please contact <LinkText typographyType="body-02" color="$color-primary-a2" underline="mobile" href='tel:911'>911.</LinkText>
                                </Notifier>

                                {FavoriteProviders.length === 0
                                    ? <Card className="no-favorite-doctors-container">
                                        <Typography type={isMobile ? "body-01" : "body-02"}>
                                            No doctors have been added.
                                        </Typography>
                                    </Card>
                                    : <div className="favorite-doctors-container">
                                        {FavoriteProviders.map((providerRow, index) => {
                                            return (
                                                <React.Fragment key={"fav_doc_" + index}>
                                                    {
                                                        providerRow.map((provider, index2) => {
                                                            return provider ? this.providerCard(provider, index2) : '';
                                                        })
                                                    }
                                                </React.Fragment>
                                            )
                                        })}
                                    </div>
                                }
                            </div>

                            <div className="col-12 col-lg-5 offset-lg-1">
                                {recentVisitedDoctors?.response?.RecentDoctors ?
                                    <div className="recent-doctors-container">
                                        <FavoriteDrHeadings heading="Doctors you have visited recently:" />
                                        {recentVisitedDoctors?.response?.RecentDoctors?.map((doc, index) =>
                                            doc ? this.recentDoctors(doc, index) : '')
                                        }
                                    </div>
                                    : recentVisitedDoctors?.waiting === true &&
                                        recentVisitedDoctors?.failure === false &&
                                        recentVisitedDoctors?.success === false
                                        ? <div className="recent-doctors-container">
                                            <MiniSpinner />
                                        </div>
                                        : ''
                                }
                                <Divider
                                    mTop={"none"}
                                    mBottom="medium"
                                    mLeft="none"
                                    mRight="none"
                                />
                                <FavDocTips />
                            </div>
                        </div>
                }
            </React.Fragment>
        );
    }

};



const mapStateToProps = (state, ownProps) => {

    const healthPlanId = state.session.currentHealthPlanInfo
        && state.session.currentHealthPlanInfo.ProviderKey ? state.session.currentHealthPlanInfo.ProviderKey : '';

    const insurancePlan = state.session.insuranceName ? state.session.insuranceName :
        state.memberships.hasAnySWHP ? "Baylor Scott & White Health Plan" : state.memberships.hasFC ? "FirstCare Health Plans" : "";
    return {
        UserName: state.domain.un,
        Token: state.domain.t,
        IsLoggedIn: state.domain.li,
        FavoriteProviders: state.healthSource.favoriteProvidersCards,
        fetchingFavoriteProviders: state.healthSource.fetchingFavoriteProviders,
        history: state.session.history,
        directNpiList: state.directScheduling.providerNpiList,
        directNpiListPending: state.directScheduling.providerListPending,
        onlineSchedulingEnabled: state.memberships.isActiveFeature_OnlineAppointmentScheduling,
        recentVisitedDoctors: state.healthSource.recentVisitedDoctors,
        screenBreakPoint: state.common.screenBreakPoint,
        hasSWHP: state.memberships.hasAnySWHP,
        hasFC: state.memberships.hasFC,
        providers: state.providers.providers,
        stateAddress: state.locations.state,
        cityAddress: state.locations.city,
        latitude: state.locations.latitude,
        longitude: state.locations.longitude,
        isCurrentLocation: state.locations.isCurrentLocation,
        geolocationError: state.locations.geolocationError,
        locations: state.locations.locations,
        networkCode: state.session.networkCode,
        healthPlanId: healthPlanId,
        insuranceName: insurancePlan,
        waitingOnGeoAddress: state.locations.waitingOnGeoAddress,
        waitingOnGeoLocation: state.locations.waitingOnGeoLocation,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadFavoriteProviders: () => {
            dispatch({
                type: types.GET_FAVORITE_PROVIDERS_START
            });
        },
        loadRecentVisitedDoctors: () => {
            dispatch({
                type: types.GET_RECENT_VISITED_DOCTORS_START
            });
        },
        getGeoLocation: (useCurrentLocation) => dispatch({ type: types.GEOLOCATION, useCurrentLocation: useCurrentLocation }),
        updateUsesMyBSWHealth: (usesMyBSWHealth) => {
            dispatch({
                type: types.UPDATE_USEMYBSWHEALTH_FILTER, usesMyBSWHealth: usesMyBSWHealth
            });
        },

    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyFavoriteProviders));